import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=3b378702&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&lang=js"
import style1 from "./OrganizationPage.vue?vue&type=style&index=1&id=3b378702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b378702",
  null
  
)

export default component.exports